//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowInstructionLink from '../../components/common/ContainerRowInstructionLink'
import InvoiceHeaderContainer from './InvoiceHeaderContainer'

const InvoiceDataExtractionForm = props => {
    const { location } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <ContainerRowInstructionLink docLink={query.docUrl} instructionLink={'https://docs.google.com/document/d/e/2PACX-1vTi_jAVkGKPeGedpb5LMBU-fzjdi7THzdwX36BUTCs9f_taAQIMpImASLRCab6BwvKUw3mG5V39MXl8/pub?embedded=true'} />
            <InvoiceHeaderContainer query={query}/>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        rhea: state.rhea
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectRhea/InvoiceDataExtractionForm.js